export default "__VITE_ASSET__CEbe3ajC__"